(() => {
  const projectId = 'wnn1ned84m';
  if (window.__joaClarityConsentInitialized) return;
  window.__joaClarityConsentInitialized = true;
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const setConsent = (marketingAllowed, analyticsAllowed) => {
    window.clarity('consentv2', {
      ad_Storage: marketingAllowed === true ? 'granted' : 'denied',
      analytics_Storage: analyticsAllowed === true ? 'granted' : 'denied',
      source: 101
    });
  };

  setConsent(false, false);
  if (!document.querySelector(`script[src*="clarity.ms/tag/${projectId}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${projectId}?ref=shopify`;
    document.head.appendChild(script);
  }

  let featureRequested = false;
  let attempts = 0;
  let retryTimer = null;

  const syncConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.marketingAllowed !== 'function' ||
        typeof privacy?.analyticsProcessingAllowed !== 'function') return false;
    try {
      setConsent(privacy.marketingAllowed(), privacy.analyticsProcessingAllowed());
      return true;
    } catch {
      return false;
    }
  };

  const initialize = () => {
    window.clearTimeout(retryTimer);
    if (syncConsent()) return;
    if (!featureRequested && typeof window.Shopify?.loadFeatures === 'function') {
      featureRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) featureRequested = false;
        syncConsent();
      });
    }
    attempts += 1;
    if (attempts < 20) retryTimer = window.setTimeout(initialize, 500);
  };

  document.addEventListener('visitorConsentCollected', (event) => {
    const detail = event.detail;
    if (typeof detail?.marketingAllowed === 'boolean' && typeof detail?.analyticsAllowed === 'boolean') {
      setConsent(detail.marketingAllowed, detail.analyticsAllowed);
    } else {
      syncConsent();
    }
  });
  window.addEventListener('load', initialize, { once: true });
  initialize();
})();
